<div class="section login-section" style="padding: 5px">
  <form
    fxLayout="column"
    [formGroup]="loginForm"
    fxLayoutAlign="center stretch"
    (ngSubmit)="loginSubmit()"
    *ngIf="!otp"
  >
    <div id="phone-num">
      <mat-form-field appearance="outline" class="medium-error">
        <mat-label>تلفن همراه</mat-label>
        <input
          placeholder="09123456789"
          formControlName="phone"
          required
          type="text"
          matInput
          dir="ltr"
        />
        <jam-icon matSuffix name="phone" />
        <mat-error
          *ngIf="phone.errors?.['required'] && loginForm.dirty && !loginForm.valid"
        >
          تلفن همراه الزامی است
        </mat-error>
        <mat-error
          *ngIf="phone.errors?.['pattern'] && !phone.errors?.['required'] && loginForm.dirty && !loginForm.valid"
        >
          شماره تلفن وارد شده قابل تایید نیست
        </mat-error>
      </mat-form-field>
    </div>

    <div id="password">
      <mat-form-field appearance="outline" class="long-error">
        <mat-label>رمز عبور</mat-label>
        <input
          formControlName="password"
          dir="ltr"
          required
          type="password"
          matInput
        />
        <jam-icon matSuffix name="key"></jam-icon>
        <mat-error
          *ngIf="password.errors?.['required'] && loginForm.dirty && !loginForm.valid"
        >
          رمز عبور الزامی است
        </mat-error>
        <mat-error
          *ngIf="password.errors?.['minlength'] && !password.errors?.['required'] && loginForm.dirty && !loginForm.valid"
        >
          حداقل طول رمز عبور
          {{ password.errors?.['minlength'].requiredLength | digitsEnToFa }} حرف
          و طول رمز وارد شده شما :
          {{ password.errors?.['minlength'].actualLength | digitsEnToFa }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Form actions -->
    <div class="form-actions">
      <button mat-button type="button" class="login-btn py-2 mb-2" (click)="forgetPassword()">فراموشی رمز عبور</button>
      <button
        mat-button
        mat-raised-button
        color="primary"
        class="login-btn"
        [disabled]="!loginForm.valid"
        type="submit"
      >
        ورود
        <div class="loader"></div>
      </button>
    </div>

    <!-- <div class="form-actions form-hint-btn">
      <button mat-button>رمز عبور خود را فراموش کرده‌اید؟</button>
    </div> -->
  </form>
  <form
    fxLayout="column"
    [formGroup]="forgetPasswordForm"
    fxLayoutAlign="center stretch"
    (ngSubmit)="setNewPassword()"
    *ngIf="forgetPasswordStep === 2"
  >

    <div id="password">
      <mat-form-field appearance="outline" class="long-error">
        <mat-label>رمز عبور</mat-label>
        <input
          formControlName="newPassword"
          dir="ltr"
          required
          type="password"
          matInput
        />
        <jam-icon matSuffix name="key"></jam-icon>
        <mat-error
          *ngIf="newPassword?.errors?.['required'] && forgetPasswordForm?.dirty && !forgetPasswordForm?.valid"
        >
          رمز عبور الزامی است
        </mat-error>
        <mat-error
          *ngIf="newPassword?.errors?.['minlength'] && !newPassword?.errors?.['required'] && forgetPasswordForm?.dirty && !forgetPasswordForm?.valid"
        >
          حداقل طول رمز عبور
          {{ newPassword?.errors?.['minlength'].requiredLength | digitsEnToFa }} حرف
          و طول رمز وارد شده شما :
          {{ newPassword?.errors?.['minlength'].actualLength | digitsEnToFa }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Form actions -->
    <div class="form-actions">
      <button
        mat-button
        mat-raised-button
        color="primary"
        class="login-btn"
        [disabled]="!forgetPasswordForm.valid"
        type="submit"
      >
        ثبت رمز جدید
        <div class="loader"></div>
      </button>
    </div>

    <!-- <div class="form-actions form-hint-btn">
      <button mat-button>رمز عبور خود را فراموش کرده‌اید؟</button>
    </div> -->
  </form>
  <form
    *ngIf="(otp || forgetPass) && forgetPasswordStep === 1"
    fxLayout="column"
    [formGroup]="loginOtp"
    fxLayoutAlign="center stretch"
    (ngSubmit)="loginWithOtp()"
  >
    <div id="phone-num">
      <mat-form-field appearance="outline" class="medium-error">
        <mat-label>تلفن همراه</mat-label>
        <input
          placeholder="09123456789"
          formControlName="phone"
          required
          type="text"
          matInput
          dir="ltr"
          #phoneForOtp
        />
        <jam-icon matSuffix name="phone" />
        <mat-error
          *ngIf="loginOtp.controls['phone'].errors?.['required'] && loginForm.dirty && !loginForm.valid"
        >
          تلفن همراه الزامی است
        </mat-error>
        <mat-error
          *ngIf="loginOtp.controls['phone'].errors?.['pattern'] && !phone.errors?.['required'] && loginForm.dirty && !loginForm.valid"
        >
          شماره تلفن وارد شده قابل تایید نیست
        </mat-error>
      </mat-form-field>
    </div>
    <div id="password">
      <mat-form-field appearance="outline" class="long-error">
        <mat-label>کد یک‌بار مصرف</mat-label>
        <input
          formControlName="code"
          dir="ltr"
          required
          type="code"
          matInput
          #codeForOtp
        />
        <jam-icon matSuffix name="key"></jam-icon>
        <mat-error
          *ngIf="loginOtp.controls['code'].errors?.['required'] && loginForm.dirty && !loginForm.valid"
        >
          کد یک‌بار مصرف الزامی است
        </mat-error>
        <mat-error
          *ngIf="loginOtp.controls['code'].errors?.['minlength'] && !loginOtp.controls['code'].errors?.['required'] && loginForm.dirty && !loginForm.valid"
        >
          کد یک‌بار مصرف
          {{ loginOtp.controls['code'].errors?.['minlength'].requiredLength | digitsEnToFa }} رقمی است.
        </mat-error>
      </mat-form-field>
    </div>
    <button mat-button (click)="resendCode()" type="button" [disabled]="codeTimer >= 0" class="resend-code-btn mb-2" *ngIf="otpStep === 2">
      <span class="timer" *ngIf="codeTimer >= 0">{{(codeTimer | minuteSecond) || '00:00'}}</span>
      <span *ngIf="codeTimer >= 0"> تا </span>
      <span>دریافت مجدد کد فعال‌سازی</span>
    </button>
    <div class="form-actions">
      <button
        mat-button
        mat-raised-button
        color="primary"
        class="login-btn"
        [disabled]="!loginOtp.valid || loading"
        type="submit"
      >
        <span *ngIf="!loading">
          <span *ngIf="otpStep === 1">درخواست کد</span>
          <span *ngIf="otpStep === 2">تایید کد و ورود</span>
        </span>
        <span *ngIf="loading">در حال ارسال...</span>
      </button>
    </div>
  </form>
</div>
